export default __webpack_public_path__ + "static/media/kids.a9904d3c.png";